<template>
  <AppBar />
  <NavDrawer />
  <ThemeDrawer />

  <VMain style="--v-layout-top: 0px;">
    <NuxtPage />
  </VMain>

  <AppFooter />
</template>